import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

console.log('🔥 Inicializando Firebase...');
console.log('   Config:', {
  apiKey: firebaseConfig.apiKey ? '✅ OK' : '❌ FALTA',
  projectId: firebaseConfig.projectId || '❌ FALTA',
  messagingSenderId: firebaseConfig.messagingSenderId ? '✅ OK' : '❌ FALTA',
});

// Initialize Firebase
const app = initializeApp(firebaseConfig);
console.log('✅ Firebase App inicializada');

// Initialize Firebase Cloud Messaging
let messaging = null;
try {
  messaging = getMessaging(app);
  console.log('✅ Firebase Messaging inicializado');
} catch (error) {
  console.error('❌ Firebase Messaging error:', error);
  console.warn('   Firebase Messaging not supported:', error.message);
}

export { messaging, getToken, onMessage };
